import { Card } from "primereact/card"
import { Button } from "primereact/button"
import gpraStyles from "../../styles/Participant-GPRA.module.css"
import PropTypes from "prop-types"
import { useNavigate } from "react-router-dom"
import ROUTES from "../../components/Routes/routesContants"
import { useContext, useState } from "react"
import { GpraContext } from "../../context/gpraContext"
import { DateTime } from "luxon"
import { Dialog } from "primereact/dialog"
import axios from "axios"
import { UserContext } from "../../context/userContext"
import { endpoints } from "../../config/gpraApiEndpoints"
import { gpraUrl } from "../../config/microservicesUrls"
import { Tooltip } from "primereact/tooltip"
import { editAuthorized } from "./utils/utils"
import EditConfigDialog from "./EditConfirmDialog"

const InterviewCard = (props) => {
  const {
    completed,
    availability_date,
    completed_date,
    due_date,
    close_date,
    title,
    type,
    loadingStatus,
    updateUrl,
    inactiveParticipant,
    started,
    blocked,
    start_date,
    clearContext,
    creator_staff_id,
    setEditMode,
  } = props

  const [showEditConfirmation, setShowEditConfirmation] = useState(false)

  const setNavigation = (edit) => {
    if (completed && !edit) {
      switch (title) {
        case "Intake":
          handleSummary(true)
          updateUrl(ROUTES.GPRA_SUMMARY_INTAKE)
          break
        case "Follow Up":
          handleSummary(true)
          updateUrl(ROUTES.GPRA_SUMMARY_FOLLOWUP)
          break
        case "Discharge":
          handleSummary(true)
          updateUrl(ROUTES.GPRA_SUMMARY_DISCHARGE)
          break
        default:
          break
      }
    } else {
      handleSummary(false)
      let route =
        title === "Intake" || !title
          ? ROUTES.GPRA_RECORDMGMT
          : title === "Discharge"
          ? ROUTES.GPRA_DISCHARGE_START
          : ROUTES.GPRA_FOLLOWUP_START

      navigation(route)
    }
  }
  const disabledInterview = () => {
    return (
      completed_date === "No date" &&
      due_date === "No date" &&
      availability_date === "No date"
    )
  }
  const { handleInterviewType, handleSummary } = useContext(GpraContext)
  const [showWarning, setShowWarning] = useState(false)
  const navigation = useNavigate()
  const userCtx = useContext(UserContext)

  const cardHeader = (
    <div className={gpraStyles.interviewCardHeader}>
      <h3>
        <b>{title}</b>
      </h3>
      {!disabledInterview() && (
        <h3>
          <b>Status: {completed ? "Completed" : "Not Completed"}</b>
        </h3>
      )}
    </div>
  )
  const availDate = DateTime.fromISO(availability_date, {
    zone: "utc",
  }).toLocal()
  const completedDate = DateTime.fromISO(completed_date, {
    zone: "utc",
  }).toLocal()
  const dueDate = DateTime.fromISO(due_date, {
    zone: "utc",
  }).toLocal()
  const closeDate = DateTime.fromISO(close_date, {
    zone: "utc",
  }).toLocal()
  const actualDate = DateTime.now()
  const startDate = DateTime.fromISO(start_date, {
    zone: "utc",
  }).toLocal()
  const available = () => {
    if (!completed) {
      return (
        availDate.startOf("year") <= actualDate.startOf("year") &&
        availDate.startOf("month") <= actualDate.startOf("month") &&
        availDate.startOf("day") <= actualDate.startOf("day")
      )
    } else {
      return true
    }
  }
  const setAvailDate = () => {
    if (availability_date === "No date") {
      return "Not available"
    } else {
      if (close_date) {
        return `${availDate.toLocaleString()} - ${closeDate.toLocaleString()}`
      }
    }
    return availDate.toLocaleString()
  }
  const checkInactiveParticipant = () => {
    if (inactiveParticipant) {
      if (title === "Discharge") {
        if (available()) {
          return false
        }
        return true
      } else {
        if (started) {
          return false
        }
        return true
      }
    }
  }
  const checkStatus = (edit) => {
    const config = {
      headers: {
        Authorization: `Bearer ${userCtx.tokenGpra}`,
      },
    }
    axios
      .post(
        `${gpraUrl()}${endpoints.CHECK_ADDITIONAL_STATUS}`,
        {
          organization_uuid: userCtx.session.user.organization_id,
          staff_id: userCtx.session.user.staff_id,
          organizations: [],
        },
        config
      )
      .then((response) => {
        if (!response?.data?.blocked && !blocked) {
          handleInterviewType(type)
          setNavigation(edit)
        } else {
          if (!completed) {
            setShowWarning(true)
          }
        }
      })
  }

  return (
    <>
      <Card header={cardHeader} className={gpraStyles.card}>
        {disabledInterview() ? (
          <h3 className={gpraStyles.disabledInterviewText}>
            Not Eligible For Completion Prior to Intake
          </h3>
        ) : (
          <>
            <div className={gpraStyles.interviewCardContainer}>
              <div className={gpraStyles.interviewCardDetailsContainer}>
                <p>
                  <b>Completed: </b>
                  {loadingStatus ? (
                    <i className="pi pi-spin pi-spinner"></i>
                  ) : start_date === "No date" || !completed ? (
                    "Not completed"
                  ) : (
                    startDate.toLocaleString()
                  )}
                  <Tooltip
                    target=".custom-target-icon-delete-1"
                    position="left"
                    className="custom-tooltip"
                  >
                    <div>
                      <p
                        style={{
                          display: "inline-block",
                        }}
                      >
                        <i>Interview Date</i>
                      </p>
                    </div>
                  </Tooltip>
                  <i
                    className={`${"custom-target-icon-delete-1 pi pi-envelope p-text-secondary pi-info-circle"} ${
                      gpraStyles.interviewCardTooltipIcon
                    }`}
                  ></i>
                </p>
                <p
                  className={`${gpraStyles.p} ${gpraStyles.interviewCardDetails}`}
                >
                  <p>
                    <b>System-Completed: </b>
                    {loadingStatus ? (
                      <i className="pi pi-spin pi-spinner"></i>
                    ) : completed_date === "No date" || !completed ? (
                      "Not completed"
                    ) : (
                      completedDate.toLocaleString()
                    )}
                    <Tooltip
                      target=".custom-target-icon-delete-2"
                      position="left"
                      className="custom-tooltip"
                    >
                      <div>
                        <p
                          style={{
                            display: "inline-block",
                          }}
                        >
                          <i>System date for interview completion</i>
                        </p>
                      </div>
                    </Tooltip>
                    <i
                      className={`${"custom-target-icon-delete-2 pi pi-envelope p-text-secondary pi-info-circle"} ${
                        gpraStyles.interviewCardTooltipIcon
                      }`}
                    ></i>
                  </p>
                </p>
                <p
                  className={`${gpraStyles.p} ${gpraStyles.interviewCardDetails}`}
                >
                  <p>
                    <b>Availability: </b>
                    {loadingStatus ? (
                      <i className="pi pi-spin pi-spinner"></i>
                    ) : (
                      setAvailDate()
                    )}
                  </p>
                </p>
                {title !== "Discharge" && (
                  <p
                    className={`${gpraStyles.p} ${gpraStyles.interviewCardDetails}`}
                  >
                    <p>
                      <b>Due: </b>
                      {loadingStatus ? (
                        <i className="pi pi-spin pi-spinner"></i>
                      ) : due_date === "No date" ? (
                        "Not due"
                      ) : (
                        dueDate.toLocaleString()
                      )}
                    </p>
                  </p>
                )}
              </div>
              <div className={gpraStyles.interviewCardButtonsContainer}>
                {completed &&
                  editAuthorized(
                    userCtx?.session?.user?.staff_role,
                    creator_staff_id,
                    userCtx?.session?.user?.staff_id
                  ) && (
                    <div className={gpraStyles.interviewCardButton}>
                      <Button
                        label="Edit Interview"
                        style={{ backgroundColor: "#8467ad", border: "none" }}
                        disabled={
                          !available() ||
                          loadingStatus ||
                          checkInactiveParticipant()
                        }
                        onClick={() => {
                          setShowEditConfirmation(true)
                        }}
                      />
                    </div>
                  )}

                <div className={gpraStyles.interviewCardButton}>
                  <Button
                    style={{ backgroundColor: "#8467ad", border: "none" }}
                    label={completed ? "View summary" : "Complete interview"}
                    disabled={
                      !available() ||
                      loadingStatus ||
                      checkInactiveParticipant()
                    }
                    onClick={() => {
                      if (!completed) {
                        clearContext()
                      }
                      checkStatus()
                    }}
                  />
                </div>
              </div>
            </div>
          </>
        )}
      </Card>
      <Dialog
        visible={showWarning}
        onHide={() => setShowWarning(false)}
        style={{ width: "600px" }}
        modal
      >
        <p
          className="m-0"
          style={{
            marginBottom: "1rem",
            marginTop: "1rem",
            fontSize: "16px",
          }}
        >
          Some background sync/save jobs are still running, please try again in
          a few minutes
        </p>
      </Dialog>
      <EditConfigDialog
        show={showEditConfirmation}
        accept={() => {
          checkStatus(true)
          setEditMode(true)
          setShowEditConfirmation(false)
        }}
        reject={() => {
          setShowEditConfirmation(false)
        }}
        setShow={setShowEditConfirmation}
      />
    </>
  )
}
InterviewCard.propTypes = {
  completed: PropTypes.bool,
  availability_date: PropTypes.string,
  completed_date: PropTypes.string,
  due_date: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
  loadingStatus: PropTypes.bool,
}
export default InterviewCard
